import gql from 'graphql-tag';

export const FULL_MOMENT_FRAGMENT = gql`
    fragment FFullMoment on PublishedStory {
        storyId
        isExternalPoint
        header {
            title
            imageUrl
            text
            imageStyleId
        }
        importKey
        user {
            userId
        }
        categories {
            worldMapSetId
        }
        connectedMarkers {
            worldMapMarkerId
            type
        }
        cards {
            cardId
            type
            ... on AudioCard {
                audio {
                    fileUrl
                }
            }
            ... on TextCard {
                info {
                    title
                    description
                }
            }
            ... on MinorTextCard {
                info {
                    title
                    description
                }
            }
            ... on VideoCard {
                video {
                    videoId
                }
            }
            ... on LinkCard {
                links {
                    title
                    url
                }
            }
            ... on MapCard {
                location {
                    title
                    zoom
                    center {
                        lat
                        lng
                    }
                    markers {
                        lat
                        lng
                        addressLabel
                    }
                }
            }
            ... on GifCard {
                gif {
                    gifUrl
                }
            }
            ... on TwitterCard {
                twitter {
                    postId
                }
            }
            ... on InstagramCard {
                instagram {
                    postId
                }
            }
            ... on LinkedStoriesCard {
                info {
                    title
                }
                linkedStories {
                    storyIds
                }
            }
            ... on FacebookCard {
                facebook {
                    postId
                }
            }
            ... on ImageCard {
                cardId
                type
                images {
                    imageUrl
                    fullImageUrl
                }
                containImage
            }
        }
    }
`;
